module.exports = __webpack_public_path__ + "img/p-news-detail-ct-bottom.b8a449fc.png";